import React from "react";
import "./landingPage.scss";

// components
import MainHero from "../../components/pageComponents/mainHero/MainHero";
import About from "../../components/pageComponents/about/About";
import Skills from "../../components/pageComponents/skills/Skills";
import Qualifications from "../../components/pageComponents/qualifications/Qualifications";
import Projects from "../../components/pageComponents/projects/Projects";
import Contact from "../../components/pageComponents/contact/Contact";
import Reviews from "../../components/pageComponents/reviews/Reviews";

const LandingPage = () => {
  return (
    <div className="landingPage">
      <MainHero />
      <About />
      <Skills />
      <Reviews />
      <Qualifications />
      {/* <Projects /> */}
      <Contact />
    </div>
  );
};

export default LandingPage;
